import { library } from '@fortawesome/fontawesome-svg-core';
import { faBackward, faBackwardFast, faCircleCheck, faDownload, faExternalLink, faForward, faForwardFast, faPrint, faReceipt } from "@fortawesome/free-solid-svg-icons";

export default function initializeCommonIcons() {
    library.add(faBackward, faForward, faBackwardFast, faForwardFast, faPrint, faDownload, faExternalLink, faCircleCheck, faReceipt);
}